let cursor = document.getElementById('mouse');
let cursor2 = document.getElementById('mouse_secondary');
let mousePosition = {
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
};
document.onmousemove = (event) => {
    mousePosition.y = event.clientY;
    mousePosition.x = event.clientX;
}
function renderCursor() {
    cursor.style.left = mousePosition.x + 'px';
    cursor.style.top = mousePosition.y + 'px';
    cursor2.style.left = mousePosition.x + 'px';
    cursor2.style.top = mousePosition.y + 'px';
    window.requestAnimationFrame(renderCursor);
}
window.requestAnimationFrame(renderCursor);



document.querySelectorAll('a').forEach(function(el) {
    el.addEventListener('mouseover', function() {
        cursor.classList.add('_hover');
    });
    el.addEventListener('mouseout', function() {
        cursor.classList.remove('_hover');
    });
});